import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import commitement from "../../assets/commit.svg";
import Herosection from "../Herosection/Herosection";
import Offerings from "../Offerings/Offerings";
import OurService from "../Services/OurService";
import innovatewithP from '../../assets/globe.svg';
import blukraftLogo from '../../assets/logo.jpg';
import "./Home.css";

const LogoShrink = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="home-hero__logo-wrapper" aria-hidden="true">
      <div
        className={`home-hero__logo-inner ${isScrolled ? 'shrink' : ''}`}
        data-header-logo-transition="hero-logo"
      >
        <a href="/" aria-label="Blukraft Home Page" className="logo">
          <div className="logo__inner">
            <img
              src={blukraftLogo}
              alt="Blukraft"
              className="logo-img"
            />
          </div>
        </a>
      </div>
    </div>
  );
};

const HomePage = () => {
  return (
    <>
      <div className="row" style={{ height: "200px", color: "#6e0e5e" }}>
        <div className="col-6" style={{ marginTop: "5%" }}>
          <LogoShrink />
        </div>

        <div className="col-4" style={{ paddingTop: "2%", marginLeft: "6%" }}>
          <div className="home-hero__content text-snipp text-snippet--left is-visible">
            <h4 className="text-snippet__heading">blukraft global services pvt ltd</h4>
            <p className="text-snippet__text">
              Technology creates value only when it is adopted, trusted, and continuously improved.
            </p>
          </div>
        </div>
      </div>

      <Herosection />
      <div className="home-wrapper">
        <div className="home-diagonal-section">
          <div className="home-diagonal-block reverse mt-2">
            <img
              src={commitement}
              alt="Community Empowerment"
              loading="lazy"
              className="home-diagonal-image"
            />
            <div className="home-diagonal-text">
              <h3 className="home-diagonal-title" style={{ fontFamily: "Poppins", color: '#6e0e5e' }}>
                How we think
              </h3>
              <p className="home-diagonal-description" style={{ fontFamily: "Poppins" }}>
                At blukraft, we believe:
                <ul>
                  <li>Services are not an extension of sales—they are a promise of delivery</li>
                  <li>Execution quality defines long-term trust</li>
                  <li>Strong governance and accountability matter as much as technical skill</li>
                  <li>Value delivery must be measured, not assumed</li>
                </ul>
                This philosophy drives how we build teams, structure engagements, and operate alongside our customers.
              </p>
            </div>
          </div>

          <div className="home-diagonal-block mb-2">
            <img
              src={innovatewithP}
              alt="Sustainability"
              loading="lazy"
              className="home-diagonal-image"
            />
            <div className="home-diagonal-text">
              <h3 className="home-diagonal-title" style={{ fontFamily: "Poppins", color: '#6e0e5e' }}>
                Industry Coverage
              </h3>
              <p className="home-diagonal-description" style={{ fontFamily: "Poppins" }}>
                We support all major supply chain–driven industries, including:
                <ul>
                  <li>Retail</li>
                  <li>CPG</li>
                  <li>Pharma & Life Sciences</li>
                  <li>Manufacturing</li>
                  <li>Distribution</li>
                  <li>Logistics & Transportation</li>
                  <li>Warehousing & 3PL</li>
                </ul>
              </p>
            </div>
          </div>
        </div>

        <OurService />
      </div>
    </>
  );
};

export default HomePage;
